// Shared blueprint sectioning, mirroring the in-game inventory UI.
// Used by ProfilePage (per-member owned blueprints) and BlueprintsPage
// (org-wide tracker) so both surfaces group items the same way.
//
// A blueprint is bucketed into a section by either an exact `category`
// match or its `item_group`. Anything that matches neither falls into
// "Other" so a future wiki import never silently disappears.

export const BLUEPRINT_SECTIONS = [
  { label: 'Ammo',             categories: ['Magazine', 'Battery'] },
  { label: 'Armor',            categories: ['Arms', 'Backpack', 'Core', 'Helmet', 'Legs', 'Suit', 'Undersuit'] },
  { label: 'Personal Weapons', categories: ['Pistol', 'Rifle', 'Shotgun', 'SMG', 'LMG', 'Sniper Rifle'] },
  { label: 'Ship Components',  itemGroup: 'Components' },
  { label: 'Ship Weapons',     itemGroup: 'Ship Weapons' },
  { label: 'Commodities',      itemGroup: 'Commodity' },
];

export function blueprintSectionOf(bp) {
  if (!bp) return 'Other';
  for (const sec of BLUEPRINT_SECTIONS) {
    if (sec.categories && sec.categories.includes(bp.category)) return sec.label;
    if (sec.itemGroup && bp.item_group === sec.itemGroup) return sec.label;
  }
  return 'Other';
}

// Section render order: defined order, then "Other" last.
export const BLUEPRINT_SECTION_ORDER = [...BLUEPRINT_SECTIONS.map(s => s.label), 'Other'];
